import { Application, Operation, Permissions, Role } from "../models";

/**
 * @deprecated - use the userCan function or useUserCan hook if you were using this to enforce a policy.
 */
export const getRoleFromPermissions = (permissions: Permissions): Role => {
  if (permissions.isAdvisor) {
    return "advisor";
  }
  if (permissions.isAdmin) {
    return "administrator";
  }
  if (permissions.isEditor) {
    return "editor";
  }
  return "viewer";
};

export type ActionForUserCan = "view" | "update" | "delete" | "create";

/**
 * Checks if the user is allowed to perform a given action
 * @deprecated Use next.userCan
 */
export const userCan = (
  action: ActionForUserCan,
  model: string,
  application: Application,
  operation: Operation,
): boolean => {
  if (!operation.applicationPermissions) {
    return false;
  }
  const appModels = operation.applicationPermissions[application] ?? {};
  const appKeys = Object.keys(appModels);
  let appActions: Array<string> = [];

  if (appKeys.includes(model)) {
    appActions = appModels[model];
  } else if (appKeys.includes("*") || appKeys.includes("all")) {
    appActions = appModels["*"];
  }

  return appActions.indexOf(action) >= 0 || appActions.indexOf("*") >= 0;
};
